import { useEffect, useState } from 'react'

export function useIsTouch() {
  const [isTouch, setIsTouch] = useState(() => window.matchMedia('(pointer: coarse)').matches)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(pointer: coarse)')

    function handleChange(e: MediaQueryListEvent) {
      setIsTouch(e.matches)
    }

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return isTouch
}
